@if(variant !== 'basket') {
<button class="w-12 m-b-2"
        [disabled]="!['instock','nopostcode','customStock'].includes(state)"
        [class._reducePadding]="reducedSize"
        [status]="buttonStatus"
        (click)="submit()"
        [buttonStyle]>
    {{'Delivery' | translate}}
</button>
}
@if (!googleShoppingLayout) {
<div [style.minHeight.px]="15">
    <div class="flex flex-middle flex-justify-center center col-1"
         [ngClass]="[variant === 'PDP' && (client.isX || client.isL) ? 'c1 ': 'c2', stateColor]">
        @if(!reducedSize) {
        <i class="icon-delivery m-r-2 icon-medium"></i>
        }
        @switch(state) {
        @case ('nopostcode'){
        {{ (variant === 'PDP' ? 'Enter postcode for local availability' : 'Delivery is available') | translate }}
        }
        @case ('none'){
        <span>{{ 'Delivery unavailable' | translate }}</span>
        }
        @case ('busy'){
        <loader></loader>
        }
        @case ('instock'){
        {{ (variant === 'basket' ? 'Delivery is available' : 'Available to % in 1 working day') | translate : postcode
        }}
        }
        @case ('customStock'){
        <span>{{ (!!product.deliveryRuleLabel ? 'Available to % in %' : 'Delivery is available' ) | translate :
            postcode : product.deliveryRuleLabel
            }}</span>
        }
        @case ('error'){
        <span>{{ 'Error:' | translate }} {{ error || 'Unexpected error' }}</span>
        }
        }
    </div>
</div>

@if(variant === 'PDP' && !['none'].includes(state)) {
<p class="center col-1 m-t-2 m-t-1-s"
   [sizeClass]="'SM: c2, XL: s2'">
    <button (click)="openPostocodeSelection()"
            [inlineButton]>{{(client.isS ? 'Change' : 'Change Address') | translate}}</button>
</p>
}
}
<result class="block"
        [status]="buttonStatus"></result>
